
import { IDeleteItemProcessoIndicadorUseCase } from "../../../presentation/useCases/delete/delete_item_processos_indicador_servicos_use_case";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";

// DeleteItemProcessoIndicadorUseCase

export class DeleteItemProcessoIndicadorUseCase implements IDeleteItemProcessoIndicadorUseCase {
  constructor(private readonly repository: IQualidadeRepository) {}

  async deleteItemProcessoIndicador( IdItemProcessoIndicador: number, IdItemProcesso: number): Promise<void> {
    await this.repository.deleteItemProcessoIndicador(IdItemProcessoIndicador, IdItemProcesso );
  }
}
